<template>

    <div id="app">
        <v-app id="inspire">

            <v-app-bar app >
                <v-toolbar-title class="d-flex">
                    <router-link to="/" tag="span" class="pointer pl-3 pr-5 mt-auto mb-auto">
                        <v-img
                                v-if="!this.$vuetify.theme.dark"
                                alt="Foodison logo"
                                src="@/assets/logo.svg"
                                max-height="auto"
                        ></v-img>
                        <v-img
                                v-else
                                alt="Foodison logo"
                                src="@/assets/d-logo.svg"
                                max-height="auto"
                        ></v-img>
                        <p class="text-caption" style="margin: -13px 0 0 0">v {{appVersion}} </p>
                    </router-link>


                </v-toolbar-title>

            </v-app-bar>
            <v-content>
                <v-container>

                    <router-view/>

                </v-container>

                <template
                        v-if=snackbarMsg
                >
                    <v-snackbar
                            :multi-line="true"
                            :timeout="7000"
                            :color=snackbarType
                            @input="closeSnackbar"
                            right
                            :value="true"
                    >
                        {{snackbarMsg}}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                                    dark
                                    flat
                                    icon
                                    @click.native="closeSnackbar"
                            >
                                <v-icon>close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </template>

            </v-content>

        </v-app>
    </div>
</template>

<script>

    export default {
        name: 'EmptyLayout',
        methods: {

            closeSnackbar() {
                this.$store.dispatch('infoSnackbar/clearSnackbar')

            },
        },
        computed: {
            appVersion(){
                return process.env.VUE_APP_V
            },
            loading() {
                return false
            },
            snackbarType() {
                return this.$store.getters['infoSnackbar/snackbarType']
            },
            snackbarMsg() {
                return this.$store.getters['infoSnackbar/snackbarMsg']
            },
        },

    };
</script>
<style scoped>

</style>
